import React, { useState, useEffect } from 'react';
import { useSearch } from '../../hooks/useSearch';
import { usePagination } from '../../hooks/usePagination';
import { useSelection } from '../../hooks/useSelection';
import Pagination from '../../components/common/Pagination';
import api from '../../api';

const BusinessPartner = () => {
    // Pagination
    const pagination = usePagination(10);
    
    const [searchTerm, setSearchTerm] = useState('');
    const [businessPartners, setBusinessPartners] = useState([]);
    
    // Search
    const { search, handleSearchChange } = useSearch((value) => {
        pagination.setPage(0);
        fetchBusinessPartners(value);
    });

    // Selection
    const {
        selectedIds,
        setSelectedIds,
        handleCheckboxClick,
        handleSelectAll
    } = useSelection();

    const fetchBusinessPartners = async (searchValue = search) => {
        try {
            const response = await api.get(`/md/business-partners/page`, {
                params: {
                    page: pagination.page,
                    size: pagination.size,
                    search: searchValue
                }
            });
            setBusinessPartners(response.data.content || []);
            pagination.setTotalPages(response.data.totalPages || 0);
            pagination.setCurrentPageItems(response.data.content?.length || 0);
            pagination.setTotal(response.data.totalElements || 0);
        } catch (error) {
            console.error('Error fetching business partners:', error);
            setBusinessPartners([]);
        }
    };

    useEffect(() => {
        fetchBusinessPartners();
    }, [pagination.page, pagination.size, search]);

    const handleSearchInputChange = (value) => {
        setSearchTerm(value);
        handleSearchChange(value);
    };

    return (
        <>
                {/* Page header */}
                <div className="page-header d-print-none">
                    <div className="container-xl">
                        <div className="row g-2 align-items-center">
                            <div className="col">
                                <h2 className="page-title">Business Partners</h2>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Page body */}
                <div className="page-body">
                    <div className="container-xl">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row align-items-center w-full">
                                        <div className="col">
                                        </div>
                                        <div className="col-md-auto col-sm-12">
                                            <div className="ms-auto d-flex flex-wrap btn-list">
                                                <div className="input-group input-group-flat w-auto">
                                                    <span className="input-group-text">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                                                            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                                            <path d="M21 21l-6 -6" />
                                                        </svg>
                                                    </span>
                                                    <input
                                                        id="advanced-table-search"
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        placeholder="Search..."
                                                        value={searchTerm}
                                                        onChange={e => handleSearchInputChange(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Data Table */}
                                <div className="table-responsive">
                                    <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                                        <thead>
                                            <tr>
                                                <th className="w-1">
                                                    <input
                                                        className="form-check-input m-0 align-middle"
                                                        type="checkbox"
                                                        checked={selectedIds.length === businessPartners.length && businessPartners.length > 0}
                                                        onChange={handleSelectAll(businessPartners)}
                                                    />
                                                </th>
                                                <th>Name</th>
                                                <th>Type</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {businessPartners.length > 0 ? (
                                                businessPartners.map((partner) => (
                                                    <tr key={partner.id}>
                                                        <td>
                                                            <input
                                                                className="form-check-input m-0 align-middle"
                                                                type="checkbox"
                                                                checked={selectedIds.includes(partner.id)}
                                                                onChange={e => handleCheckboxClick(e, partner.id)}
                                                            />
                                                        </td>
                                                        <td>{partner.name || 'N/A'}</td>
                                                        <td>{partner.type || 'N/A'}</td>
                                                        <td>{partner.created ? new Date(partner.created).toLocaleDateString() : 'N/A'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">No business partners found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {/* Pagination Controls */}
                                <Pagination {...pagination} />
                            </div>
                        </div>
                    </div>
                </div>
            
        </>
    );
};

export default BusinessPartner; 